function isCartPage() {
  return window.location.pathname.includes('/cart')
}

function get (url) {
  return fetch(url, {
    credentials: "same-origin",
    method: "GET",
  });
}

function getCartItemsValidation () {
  var url = "".concat('/cart', `?view=items-validation&t=${Date.now()}`);
  return get(url).then((response) => response.json());
}

function disableCheckoutButtons () {
  const checkoutButtons = document.querySelectorAll('button[name="checkout"]')
  console.log('checkoutButtons', checkoutButtons)
  checkoutButtons.forEach((checkoutButton) => {
    if (checkoutButton) {
      checkoutButton.setAttribute('disabled', true)
    }
  })
  const cartDrawerCheckoutButtons = document.querySelectorAll('a[href="/checkout"]')
  cartDrawerCheckoutButtons.forEach((cartDrawerCheckoutButton) => {
    if (cartDrawerCheckoutButton) {
      cartDrawerCheckoutButton.setAttribute('disabled', true)
    }
  })
}

function enableCheckoutButtons () {
  const checkoutButtons = document.querySelectorAll('button[name="checkout"]')
  checkoutButtons.forEach((checkoutButton) => {
    if (checkoutButton) {
      checkoutButton.removeAttribute('disabled')
    }
  })
  const cartDrawerCheckoutButtons = document.querySelectorAll('a[href="/checkout"]')
  cartDrawerCheckoutButtons.forEach((cartDrawerCheckoutButton) => {
    if (cartDrawerCheckoutButton) {
      cartDrawerCheckoutButton.removeAttribute('disabled')
    }
  })
}

function hideCartPageValidationMessage() {
  if (isCartPage()) {
    const cartValidationContainerEl = document.querySelector('.cart-items-validation__container')
    
    cartValidationContainerEl.style.display = 'none'
  }
}

async function renderCartItemsValidationMessage(e) {
  console.log(e, 'event object')
  try {
    disableCheckoutButtons()
    // const response1 = await getCartItemsValidation()
    // console.log('response1', response1)
    // const response = {
    //   cartItemsValidation: {
    //     "data": {
    //       "customer": {
    //         "remainingQtyPerOrder": 9990,
    //         "isB2BUser": true,
    //         "remainingQtyPerPeriod": -7,
    //         "remainingQtyCanBuyCurrentPeriod": 2
    //       },
    //       "products": [
    //         {
    //           "productId": 8802842870019,
    //           "remainingQuantityCanBuy": -1,
    //           "title": "Candle",
    //           "maxQuantityCanBuyCurrently": 6
    //         },
    //         {
    //           "productId": 8816914694403,
    //           "remainingQuantityCanBuy": -2,
    //           "title": "Deodorants Formula Nº 2 Bergamot & Hinoki",
    //           "maxQuantityCanBuyCurrently": 0
    //         }
    //       ]
    //     },
    //     "config": {
    //       "quotationStartedAt": 1746028800,
    //       "quotationStartedAtOriginal": 1743436800,
    //       "quotationEndAt": 1747324800,
    //       "currentDate": 1746782459,
    //       "maxItemsPerOrder": 9999,
    //       "maxItemsPerPeriod": 6,
    //       "totalQuotationProductInCart": 9,
    //       "totalQuotationProductBoughtInPeriod": 4,
    //       "quotationCycleDays": 15,
    //       "humanReadableQuotationEndAt": "May 16, 2025"
    //     },
    //     "period_spent": "2"
    //   }
    // }
    const response = await getCartItemsValidation()
    console.log('response', response)
    const configData = response?.cartItemsValidation?.config || {}
    const errorsContainerEl = document.createElement('div')
    const refinedProducts = response?.cartItemsValidation?.data?.products?.reduce((result, product) => {
      if (result[product?.productId]) {
        result[product?.productId].remainingQuantityCanBuy -= product?.quantityInCartCurrently
        result[product?.productId].quantityInCartCurrently += product?.quantityInCartCurrently
      } else {
        result[product?.productId] = product
      }
      return result
    }, {})
    console.log(refinedProducts, 'refinedProducts')
    const productErrors = Object.values(refinedProducts).filter((product) => product?.remainingQuantityCanBuy < 0)
    const customerErrors = response?.cartItemsValidation?.data?.customer?.remainingQtyPerPeriod < 0
    const hasErrors = productErrors.length > 0 || customerErrors
    errorsContainerEl.classList.add('cart-items-validation__errors')
    errorsContainerEl.innerHTML = `
      <p style="color: red;">${window?.theme?.strings?.b2b_quotation_general_exceed_limit?.replace('[[reset_date]]', configData?.humanReadableQuotationEndAt)}</p>
      <ul style="color: red;">
        ${productErrors
          .map((product) => {
            return `
              <li>
                ${window?.theme?.strings?.b2b_quotation_product_exceed_limit?.replace('[[product_title]]', `<strong>${product?.title}</strong>`)?.replace('[[max_qty_per_period]]', `<strong>${product?.maxQuantityCanBuyCurrently}</strong>`)}
              </li>
            `
          }).join('')}
        
        ${customerErrors ? `
          <li>
            ${window?.theme?.strings?.b2b_quotation_cart_exceed_limit?.replace('[[total_qty_per_period]]', `<strong>${response?.cartItemsValidation?.data?.customer?.remainingQtyCanBuyCurrentPeriod}</strong>`)}
          </li>
        ` : ''}
      </ul>
    `
  if (hasErrors) {
    const itemsValidationMessageEls = document.querySelectorAll('.js-cart-errors')
    itemsValidationMessageEls.forEach((itemsValidationMessageEl) => {
      if (itemsValidationMessageEl) {
        itemsValidationMessageEl.innerHTML = errorsContainerEl.outerHTML
      }
    })
  } else {
    const itemsValidationMessageEls = document.querySelectorAll('.js-cart-errors')
    itemsValidationMessageEls.forEach((itemsValidationMessageEl) => {
      if (itemsValidationMessageEl) {
        itemsValidationMessageEl.innerHTML = ''
      }
    })
    enableCheckoutButtons()
  }
  } catch(error) {
    console.error(error)
    const itemsValidationMessageEls = document.querySelectorAll('.js-cart-errors')
    itemsValidationMessageEls.forEach((itemsValidationMessageEl) => {
      if (itemsValidationMessageEl) {
        itemsValidationMessageEl.innerHTML = ''
      }
    })
    enableCheckoutButtons()
    // hideCartPageValidationMessage()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // document.addEventListener('line-item:change:end', renderCartItemsValidationMessage);
  // document.addEventListener('cart:item-added', renderCartItemsValidationMessage);
  // document.addEventListener('cart:items-updated', renderCartItemsValidationMessage);
  // document.addEventListener('cart-drawer:init:end', renderCartItemsValidationMessage);
  document.addEventListener('cart:updated', renderCartItemsValidationMessage);
  document.addEventListener('ajaxProduct:added', renderCartItemsValidationMessage);
  document.addEventListener('theme:cartchanged', renderCartItemsValidationMessage);
  renderCartItemsValidationMessage()
});
